import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "relative mt-2",
  ref: "datePicker"
}
const _hoisted_2 = { class: "absolute left-0 top-0 flex flex-col items-center justify-center h-full w-10 bg-gray-600 rounded-l-md" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between text-gray-700" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "grid-cols-7 gap-1 grid my-2" }
const _hoisted_6 = { class: "grid-cols-7 gap-1 grid" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-600"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Label = _resolveComponent("Label")
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Label, {
      error: _ctx.error,
      labelId: _ctx.labelId,
      label: _ctx.label
    }, null, 8, ["error", "labelId", "label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_CalendarIcon, { class: "w-5 h-5 text-white" })
      ]),
      _createVNode("input", {
        id: _ctx.labelId,
        class: ["w-full py-2 pl-12 pr-2 text-gray-500 border rounded outline-none", {
					'border-gray-300 focus:border-primary': !_ctx.error,
					'border-red-600': _ctx.error,
				}],
        type: "text",
        value: _ctx.formatTimeZone('yyyy-MM-dd', 'UTC', _ctx.value),
        autocomplete: _ctx.type !== 'password' ? 'on' : 'off',
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.selected = !_ctx.selected)),
        "aria-labelledby": _ctx.labelId,
        readonly: ""
      }, null, 10, ["id", "value", "autocomplete", "aria-labelledby"]),
      _createVNode("div", {
        class: ["bg-white px-4 py-3 absolute left-0 top-0 w-64 min-h-64 shadow-2xl z-50 origin-top-left transform translate-y-12 transition ease-out duration-200", {
					'scale-100 opacity-100': _ctx.selected,
					'scale-0 opacity-0': !_ctx.selected,
				}]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            fab: "",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.dateCounter--))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ChevronLeftIcon, { class: "cursor-pointer w-4 h-4" })
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formatTimeZone('MMMM yyyy', 'UTC', _ctx.dateHeader)), 1),
          _createVNode(_component_Button, {
            fab: "",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.dateCounter++)),
            class: "translate-x-2 transform"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ChevronRightIcon, { class: "cursor-pointer w-4 h-4" })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
            return (_openBlock(), _createBlock("span", {
              class: "text-center text-sm text-gray-500",
              key: index
            }, _toDisplayString(day), 1))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.daysList, (date, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              (date > 31)
                ? (_openBlock(), _createBlock("span", _hoisted_7, " "))
                : _createCommentVNode("", true),
              (date < 32)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: ["text-sm py-1 rounded-full text-center w-full focus:outline-none focus:shadow-outline", {
								'text-gray-600 bg-white hover:bg-gray-200 border-0':
									!_ctx.isSelected(date + 1) && !_ctx.isToday(date + 1),
								'text-white bg-primary border-0': _ctx.isSelected(
									date + 1
								),
								'text-primary shadow-inner bg-gray-200':
									_ctx.isToday(date + 1) && !_ctx.isSelected(date + 1),
							}],
                    onClick: $event => (_ctx.updateValue(date + 1))
                  }, _toDisplayString(date + 1), 11, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ], 2)
    ], 512),
    (_ctx.error)
      ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}